import { RepaymentLevelType } from '../../../../../constants/src/';

export default {
    loanId: null,
    returnUrl: '',
    searchText: undefined,
    editStdLoanModal: {
        isOpen: false,
    },
    loanSummaryModal: {
        isOpen: false,
    },
    editMasterNoteModal: {
        isOpen: false,
    },
    repaymentModal: {
        isOpen: false,
        entityLevel: RepaymentLevelType.Property,
    },
    borrowerEditModal: {
        isOpen: false,
    },
    deleteLoanModal: {
        isOpen: false,
    },
    loanActionModal: {
        isOpen: false,
    },
    cancelInsuranceModal: {
        isOpen: false,
    },
    loseLoanModal: {
        isOpen: false,
    },
    closeLoanModal: {
        isOpen: false,
    },
    extensionModal: {
        isOpen: false,
    },
    holdbackReleaseModal: {
        isOpen: false,
    },
    rentalDscrModal: {
        isOpen: false,
    },
    buildRentConversionModal: {
        isOpen: false,
    },
    linkLoanWithBClientModal: {
        isOpen: false,
    },
    revertToApprovedModal: {
        isOpen: false,
    },
    restoreLoanModal: {
        isOpen: false,
    },
    propertyInsuranceModal: {
        isOpen: false,
    },
    changeLoanTypeModal: {
        isOpen: false,
    },
    terminateMasterNoteModal: {
        isOpen: false,
    },
    auditHistoryModal: {
        isOpen: false,
    },
    loanSetupSheetModal: {
        isOpen: false,
    }
};
